export default "__VITE_ASSET__DoLLKXEF__$_?url__"